/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AccessGrantListEntryFromJSON, AccessGrantListEntryToJSON, MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, } from './';
export function PagedResponseOfAccessGrantListEntryFromJSON(json) {
    return PagedResponseOfAccessGrantListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfAccessGrantListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(AccessGrantListEntryFromJSON))
    };
}
export function PagedResponseOfAccessGrantListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'previousPage': PageRequestToJSON(value.previousPage),
        'size': value.size,
        'hasNext': value.hasNext,
        'nextPage': PageRequestToJSON(value.nextPage),
        'metaData': MetaDataToJSON(value.metaData),
        'page': value.page,
        'hasPrevious': value.hasPrevious,
        'numberOfElements': value.numberOfElements,
        'totalElements': value.totalElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(AccessGrantListEntryToJSON))
    };
}
